import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { combineLatest, merge, of, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { TextHighlightService } from '../../service/text-highlight/text-highlight-service';
import { SampleTrackerData } from '../../group-info/study-group-info';
import { UrlBuilder } from '../../../core';
import { containsCaseInsensitive } from '../../../core/search-functions';

@Component({
    selector: 'app-protocols',
    template: require('./protocols.component.html'),
    styles: [require('./protocols.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProtocolsComponent implements OnDestroy {

    public searchTerm = new FormControl('');
    public studyListInfo: SampleTrackerData[] = [];
    public loadingComplete = false;
    private subscription: Subscription;

    constructor(
        private sampleTrackingStorage: SampleTrackingStorage,
        private textHighlighterService: TextHighlightService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private urlBuilder: UrlBuilder
    ) {

        const searchTermFlow = merge(
            of(''),
            this.searchTerm.valueChanges
                .pipe(
                    debounceTime(300),
                    distinctUntilChanged()
                )
        );

        const data$ = this.sampleTrackingStorage.loadStudies();

        this.subscription = combineLatest([
            data$,
            searchTermFlow
        ]).pipe(
            map(([studies, term]: [SampleTrackerData[], string]) =>
                [this.applyQuickSearchFilter(studies, term)]
            ))
            .subscribe(([studies]: [SampleTrackerData[]]) => {
                this.studyListInfo = studies;
                this.loadingComplete = true;
                this.changeDetectorRef.markForCheck();
            });
    }

    public onProtocolClick(study: SampleTrackerData) {
        localStorage.setItem('dashboardData', JSON.stringify(study));
        this.urlBuilder
            .esa()
            .sampletracking()
            .protocolInfo(study)
            .navigate();
        return;
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private applyQuickSearchFilter(data: SampleTrackerData[], term: string) {
        return term ? data.filter(protocol => containsCaseInsensitive(protocol.protocolCode, term)) : data;
    }
}